import "baguettebox.js/dist/baguetteBox.css";
import baguetteBox from "baguettebox.js";

export default function lightboxInitialize() {
  if (document.querySelector(".ce-gallery")) {
    baguetteBox.run(".ce-gallery", {
      // Options documented at https://www.npmjs.com/package/baguettebox.js
      filter:
        /(^(?!https:\/\/commons\.wikimedia\.).+\.(gif|jpe?g|png|webp)$)|(\/index\.php\?eID=dumpFile&t=([pf])&\4=\d+&token=[a-z0-9]+)/i,
      overlayBackgroundColor: "rgba(0, 0, 0, .5)",
    });
  }
}
